import { Form, Input, InputNumber } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

const SyncTime: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Form.Item
      name="allowedReadingSyncTime"
      label="Sync Time (In Minutes)"
      rules={[
        {
          required: true,
          message: t("error:sync_time_is_required"),
        },
      ]}
    >
      <InputNumber
        style={{ width: "100%" }}
        controls={false}
        changeOnWheel={false}
      />
    </Form.Item>
  );
};

export default SyncTime;
